export default "__VITE_ASSET__y_T1_htr__"